
// import React from "react";
// import { Link } from "react-router-dom";

// import { motion } from "framer-motion";
// import "./Footer.css";
// import logo from "../../assets/ATH LOGOs/logo.png";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
//   FaGoogle,
// } from "react-icons/fa";

// function Footer() {
//   return (
//     <motion.footer
//       className="footer"
//       initial={{ y: 120, opacity: 0 }}
//       whileInView={{ y: 0, opacity: 1 }}
//       viewport={{ once: false, amount: 0.3 }}
//       transition={{ type: "spring", stiffness: 100, damping: 20 }}
//     >
//       <img src={logo} alt="Atlas Travels Logo" className="footer-logo" />
//       <p className="footer-tagline">Creating journeys, not just trips.</p>

//       <div className="footer-main">
//         <div className="footer-section">
//           <h3>Quick Links</h3>
//           <ul>
//             <li>
//               <Link to="/">Home</Link>
//             </li>
//             <li>
//               <Link to="/events">Events</Link>
//             </li>
//             <li>
//               <Link to="/TripsOverview">Trips Overview</Link>
//             </li>
//             <li>
//               <Link to="/about">About Us</Link>
//             </li>
//             <li>
//               <Link to="/packages">Packages</Link>
//             </li>
//             <li>
//               <Link to="/Blog">Blog</Link>
//             </li>
//             <li>
//               <Link to="/contact">Contact Us</Link>
//             </li>
//           </ul>
//         </div>

//         <div className="footer-section">
//           <h3>Services</h3>
//           <ul>
//             <li>
//               <Link to="/visa">Visa Assistance</Link>
//             </li>
//             <li>
//               <Link to="/mice">Corporate Travel (MICE)</Link>
//             </li>
//             <li>
//               <Link to="/rnr">RnR (Rewards & Recognition)</Link>
//             </li>
//             <li>
//               <Link to="/packages">Customized Travel Plans</Link>
//             </li>
//           </ul>
//         </div>

//         <div className="footer-section1">
//           <h3>Policies</h3>
//           <ul>
//             <li>
//               <Link to="/terms">Terms & Conditions</Link>
//             </li>
//             <li>
//               <Link to="/privacy">Privacy Policy</Link>
//             </li>
//             <li>
//               <Link to="/refund">Payments & Refund Policy</Link>
//             </li>
//           </ul>
//         </div>
//         <div className="footer-section1">
//           <h3>Contact Us</h3>
//           <p>
//             📍Building A5, 3rd Floor, Shankar Garden, Vikaspuri Next to Kia
//             Showroom | Metro Pillar No. 618 | Delhi India
//           </p>
//           <a href="tel:+919971881444" className="call-btn">
//             <p className="callbutton">📞 Call Now </p>{" "}
//           </a>
//           <p>sales@atlastravelhouse.com</p>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <div className="footer-social">
        
//           <a
//             href="https://www.instagram.com/atlastravelhouse_ath"
//             target="_blank"
//           >
//             <FaInstagram />
//           </a>
//           <a
//             href="https://www.linkedin.com/company/atlas-travel-house/posts/?feedView=all"
//             target="_blank"
//           >
//             <FaLinkedinIn />
//           </a>
//           <a
//             href="https://www.youtube.com/@AtlasTravelHouse/shorts"
//             target="_blank"
//           >
//             <FaYoutube />
//           </a>
//           <a href="https://share.google/YU0EFdmLomQRorJf7" target="_blank">
//             <FaGoogle />
//           </a>
//         </div>
//         <p className="copyright">
//           © {new Date().getFullYear()} Atlas Travels. All rights reserved.
//         </p>
//       </div>
//     </motion.footer>
//   );
// }

// export default Footer;




// import React from "react";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
//   FaGoogle,
//   FaMapMarkerAlt,
//   FaPhoneAlt ,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";
// import "./Footer.css";
// // import FooterBottom from "./SocialLinks";
// import logo from "../../assets/ATH LOGOs/logo.png";

// function Footer() {
//   return (
//     <motion.footer
//       className="footer"
//       initial={{ y: 120, opacity: 0 }}
//       whileInView={{ y: 0, opacity: 1 }}
//       viewport={{ once: false, amount: 0.3 }}
//       transition={{ type: "spring", stiffness: 100, damping: 20 }}
//     >
//       <img src={logo} alt="Atlas Travel House Logo" className="footer-logo" />
//       <p className="footer-tagline">Creating journeys, not just trips.</p>
//       <p className="footer-para">
//         Atlas Travel House specializes in corporate MICE, RnR programs, and
//         premium leisure travel solutions across India and international
//         destinations. With a strong network of global partners and a
//         detail-driven approach, we transform complex travel requirements into
//         seamless experiences. Our commitment to reliability, creativity, and
//         service excellence makes us a trusted travel partner for businesses and
//         individuals alike.{" "}
//       </p>

//       <div className="footer-main">
//         <div className="footer-section">
//           <h3>Explore</h3>
//           <ul>
//             {/* <li>
//               <Link to="/TripsOverview">Trips Overview</Link>
//             </li> */}
//             <li>
//               <Link to="/packages">Packages</Link>
//             </li>
//             <li>
//               <Link to="/events">Events</Link>
//             </li>
//           </ul>
//         </div>
        
//        <div className="footer-section">
//           <h3 className="company">Company</h3>
//           <ul>
//             <li>
//               <Link to="/">Home</Link>
//             </li>
//             <li>
//               <Link to="/about">About Us</Link>
//             </li>
//             <li>
//               <Link to="/Blog">Blog</Link>
//             </li>
//             <li>
//               <Link to="/contact">Contact Us</Link>
//             </li>
//           </ul>
//         </div>
//         <div className="footer-section">
//           <h3>Travel Services</h3>
//           <ul>
//             <li>
//               <Link to="/mice">Corporate Travel (MICE)</Link>
//             </li>
//             <li>
//               <Link to="/rnr">RnR (Rewards & Recognition)</Link>
//             </li>
//             <li>
//               <Link to="/visa">Visa Assistance</Link>
//             </li>
//             <li>
//               <Link to="/packages">Customized Travel Plans</Link>
//             </li>
//           </ul>
//         </div>

 

//         <div className="footer-section1">
//           <h3>Legal</h3>
//           <ul>
//             <li>
//               <Link to="/terms">Terms & Conditions</Link>
//             </li>
//             <li>
//               <Link to="/privacy">Privacy Policy</Link>
//             </li>
//             <li>
//               <Link to="/refund">Payments & Refund Policy</Link>
//             </li>
//           </ul>
//         </div>

//         <div className="footer-section1">
//           <h3>Contact</h3>
//           {/* <p>
//             <FaMapMarkerAlt style={{ marginRight: "4px" }} />
//             Building A5, 3rd Floor, Shankar Garden, Vikaspuri Next to Kia
//             Showroom | Metro Pillar No. 618
//           </p>
//           <p>sales@atlastravelhouse.com</p> */}
//            <p>
//             <FaMapMarkerAlt style={{ marginRight: "4px" }} />
//             Building A5, 3rd Floor, Shankar Garden, Vikaspuri Next to Kia
//             Showroom | Metro Pillar No. 618 | West Delhi India.
//           </p>
//           <p>Email : sales@atlastravelhouse.com</p>

//           <a href="tel:+919971881444" className="call-btn">
//             <p className="callbutton">  <FaPhoneAlt  style={{ marginRight: "8px" }} /> Call Now</p>
//           </a>
//         </div>
//       </div>
//       <div className="footer-bottom">
//         <div className="footer-social">
//           <a
//             href="https://www.instagram.com/atlastravelhouse_ath"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <FaInstagram />
//           </a>

//           <a
//             href="https://www.linkedin.com/company/atlas-travel-house/posts/?feedView=all"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <FaLinkedinIn />
//           </a>

//           <a
//             href="https://www.youtube.com/@AtlasTravelHouse/shorts"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <FaYoutube />
//           </a>

//           <a
//             href="https://share.google/YU0EFdmLomQRorJf7"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <FaGoogle />
//           </a>
//         </div>
//       </div>
//       <p className="copyright">
//         © {new Date().getFullYear()} Atlas Travel House. All rights reserved.
//       </p>
//     </motion.footer>
//   );
// }

// export default Footer;




import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaGoogle,
  FaMapMarkerAlt,
  FaPhoneAlt ,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Footer.css";
// import FooterBottom from "./SocialLinks";
import logo from "../../assets/ATH LOGOs/logo.png";

function Footer() {
  return (
    <motion.footer
      className="footer"
      initial={{ y: 120, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: false, amount: 0.3 }}
      transition={{ type: "spring", stiffness: 100, damping: 20 }}
    >
      <img src={logo} alt="Atlas Travel House Logo" className="footer-logo" />
      <p className="footer-tagline">Creating journeys, not just trips.</p>
      <p className="footer-para">
        Atlas Travel House specializes in corporate MICE, RnR programs, and
        premium leisure travel solutions across India and international
        destinations. With a strong network of global partners and a
        detail-driven approach, we transform complex travel requirements into
        seamless experiences. Our commitment to reliability, creativity, and
        service excellence makes us a trusted travel partner for businesses and
        individuals alike.{" "}
      </p>

      <div className="footer-main">
        <div className="footer-section">
          <h3>Explore</h3>
          <ul>
            {/* <li>
              <Link to="/TripsOverview">Trips Overview</Link>
            </li> */}
            <li>
              <Link to="/packages">Packages</Link>
            </li>
            <li>
              <Link to="/events">Events</Link>
            </li>
          </ul>
        </div>
        
       <div className="footer-section">
          <h3 className="company">Company</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/Blog">Blog</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Travel Services</h3>
          <ul>
            <li>
              <Link to="/mice">Corporate Travel (MICE)</Link>
            </li>
            <li>
              <Link to="/rnr">RnR (Rewards & Recognition)</Link>
            </li>
            <li>
              <Link to="/visa">Visa Assistance</Link>
            </li>
            <li>
              <Link to="/packages">Customized Travel Plans</Link>
            </li>
          </ul>
        </div>

 

        <div className="footer-section1">
          <h3>Legal</h3>
          <ul>
            <li>
              <Link to="/terms">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/refund">Payments & Refund Policy</Link>
            </li>
            {/* <li>
  <Link
    to="/venue-planner"
    style={{ background: "transparent" }}
  >
    Venue Planner
  </Link>
</li> */}
          </ul>
        </div>

        <div className="footer-section1">
          <h3>Contact</h3>
          <p>
            <FaMapMarkerAlt style={{ marginRight: "4px" }} />
            Building A5, 3rd Floor, Shankar Garden, Vikaspuri Next to Kia
            Showroom | Metro Pillar No. 618 | West Delhi India.
          </p>
          <p>Email : sales@atlastravelhouse.com</p>

          <a href="tel:+919971881444" className="call-btn">
            <p className="callbutton">  <FaPhoneAlt  style={{ marginRight: "8px" }} /> Call Now</p>
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-social">
          <a
            href="https://www.instagram.com/atlastravelhouse_ath"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>

          <a
            href="https://www.linkedin.com/company/atlas-travel-house/posts/?feedView=all"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedinIn />
          </a>

          <a
            href="https://www.youtube.com/@AtlasTravelHouse/shorts"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>

          <a
            href="https://share.google/YU0EFdmLomQRorJf7"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGoogle />
          </a>
        </div>
      </div>
      <p className="copyright">
        © {new Date().getFullYear()} Atlas Travel House. All rights reserved.
      </p>
    </motion.footer>
  );
}

export default Footer;
